





























import { Component, Vue, Prop } from 'vue-property-decorator'
import { faCloud } from '@fortawesome/free-solid-svg-icons'
import addFontAwesomeIcon from '../helpers/add-font-awesome-icon'
import toArray from '../helpers/to-array'
import { debounce } from 'lodash'

addFontAwesomeIcon(faCloud)

const baseHtmlTag = document.getElementsByTagName('html')[0]

@Component
export default class DropZone extends Vue {
	protected show: boolean = false
	protected counter: number = 0
	private listenersAttached = false
	private detachModalWatcher: (() => void) | null = null

	@Prop({ type: Boolean, default: false })
	readonly useOwnDrop!: boolean

	mounted() {
		this.attachDocumentListeners()

		const root = this.$root as Vue & { showingModal?: number }
		if (root && typeof root.$watch === 'function') {
			this.detachModalWatcher = root.$watch(
				() => root.showingModal,
				value => this.handleModalToggle(value as number),
				{ immediate: true }
			)
		}
	}

	beforeDestroy() {
		this.detachDocumentListeners()

		if (this.detachModalWatcher) {
			this.detachModalWatcher()
			this.detachModalWatcher = null
		}
	}

	private handleModalToggle(value: number = 0) {
		if (value > 0) {
			this.resetCounter()
			this.detachDocumentListeners()
		} else {
			this.attachDocumentListeners()
		}
	}

	private get modalActive(): boolean {
		return Boolean((this.$root as any)?.showingModal)
	}

	private attachDocumentListeners() {
		if (this.listenersAttached) {
			return
		}

		document.addEventListener('drop', this.drop)
		document.addEventListener('dragover', this.dragOver)
		document.addEventListener('dragenter', this.dragEnter)
		document.addEventListener('dragleave', this.dragLeave)

		this.listenersAttached = true
	}

	private detachDocumentListeners() {
		if (!this.listenersAttached) {
			return
		}

		document.removeEventListener('drop', this.drop)
		document.removeEventListener('dragover', this.dragOver)
		document.removeEventListener('dragenter', this.dragEnter)
		document.removeEventListener('dragleave', this.dragLeave)

		this.listenersAttached = false
	}

	private dragOver(e: DragEvent) {
		if (this.modalActive) {
			return
		}

		e.preventDefault()
	}

	dragEnter(e: DragEvent) {
		if (this.modalActive) {
			return
		}

		this.counter++

		const types = e.dataTransfer?.types
		let hasFiles = false
		if (types) {
			hasFiles = Array.from(types as ArrayLike<string>).includes('Files')
		}

		if (hasFiles) {
			e.preventDefault()

			this.show = true

			this.$parent.$el.classList.add('files-dragging')
		}
	}

	dragLeave(e: DragEvent) {
		if (this.modalActive) {
			return
		}

		e.preventDefault()

		this.counter--

		if (e.target === baseHtmlTag || !this.counter) {
			this.show = false

			this.$parent.$el.classList.remove('files-dragging')
		}
	}

	resetCounter() {
		this.show = false
		this.counter = 0

		if (this.$parent && this.$parent.$el) {
			this.$parent.$el.classList.remove('files-dragging')
		}
	}

	drop(e: DragEvent) {
		if (this.modalActive) {
			return
		}

		e.preventDefault()
		e.stopPropagation()

		this.$emit('new-drop', e)

		this.resetCounter()
	}
}
